





















import { defineComponent, PropType } from '@vue/composition-api';
import { Spacing } from '../constants';

export default defineComponent({
	props: {
		isInline: Boolean,
		spacing: {
			type: String as PropType<Spacing>,
			default: Spacing.WIDE,
		},
	},
	setup() {
		return { Spacing };
	},
});
